(function () {
    'use strict';

    angular
        .module('riskEditModule')
        .controller('RiskRelatedRiskEventsController', Controller);

    Controller.$inject = ['$scope', 'historyCtxtService', 'risk', 'relatedRiskEvents'];

    function Controller($scope, historyCtxtService, risk, relatedRiskEvents) {

        $scope.ctrlCtxt.relatedRiskEvents = relatedRiskEvents;

        // Risk event
        $scope.goToRiskEvent = function (riskEvent) {
            historyCtxtService.goToState('riskEventEdit',
                { RiskEventID: riskEvent.RiskEventID },
                'riskEdit',
                risk
            );
        };
    }
})();